import { render, staticRenderFns } from "./popupAlert.vue?vue&type=template&id=6ea7c35a"
import script from "./popupAlert.vue?vue&type=script&lang=js"
export * from "./popupAlert.vue?vue&type=script&lang=js"
import style0 from "./popupAlert.vue?vue&type=style&index=0&id=6ea7c35a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports